// random shuffle array
export const randomShuffle = (array) => { 
  const tmp =  [...array]
    for (let i = tmp.length - 1; i > 0; i--) { 
      const j = Math.floor(Math.random() * (i + 1)); 
      [tmp[i], tmp[j]] = [tmp[j], tmp[i]]; 
    } 
    console.log("to")
    console.log(tmp)
    return tmp; 
  }; 


export const swapElements = (array, index1, index2) => {
    let temp = array[index1];
    array[index1] = array[index2];
    array[index2] = temp;
};

export const insertElement = (inputArray, currentDragPosition, dropItemPosition) => {
  let reuslt
  if(dropItemPosition === 99){ // topmost droptarget
    reuslt = [
      inputArray[currentDragPosition],
      ...inputArray.slice(0, currentDragPosition),
      ...inputArray.slice(currentDragPosition + 1),
    ]
  } else if(dropItemPosition > currentDragPosition){
    // drag downstream
    reuslt = [
      ...inputArray.slice(0, currentDragPosition),
      ...inputArray.slice(currentDragPosition + 1, dropItemPosition + 1),
      inputArray[currentDragPosition],
      ...inputArray.slice(dropItemPosition + 1)
    ]
  } else {
    // drag upstream
    reuslt = [
      ...inputArray.slice(0, dropItemPosition + 1),
      inputArray[currentDragPosition],
      ...inputArray.slice(dropItemPosition + 1, currentDragPosition),
      ...inputArray.slice(currentDragPosition + 1)
    ]
  }
  return reuslt
}


export const parseContent = (content) => {
  content = content.replaceAll(";", "")
  const audioStartToken = "_audio1_"
  const audioEndToken = "_audio2_"
  if(content.includes(audioStartToken) && content.includes(audioEndToken)){
      //TODO: Assuming there is only one audio 
      //if(content.match(audioStartToken).length > 1){ ...
      const contentBeforeAudio = content.split(audioStartToken)[0]
      const audioFileName = content.split(audioStartToken)[1].split(audioEndToken)[0]
      const contentAfterAudio = content.split(audioStartToken)[1].split(audioEndToken)[1]
      return {
          contentBeforeAudio,
          audioFileName: audioFileName.replace(/\s+/g, ''), 
          contentAfterAudio
      }
  } else {
      return {
          contentBeforeAudio: content,
          audioFileName: null, 
          contentAfterAudio: null
      }
  }
}

export function arrayEquals(array1, array2) {
  console.log("compaore:")
  console.log(array1)
  console.log(array2)
  return JSON.stringify(array1) === JSON.stringify(array2)
}